module.exports = __webpack_public_path__ + "img/BM.b02f62a2.svg";